import { useTranslation } from "react-i18next";
import type { ParseKeys } from "i18next";
import { useMemo } from "react";

import styles from "./styles.module.scss";
import type { IErrorCode, IErrorComponentProps } from "./types";

import { Typography } from "@/components/atoms/typography";
import { Button } from "@/components/atoms/button";

const error404 = "/assets/images/404.svg";
const error500 = "/assets/images/500.svg";

const errorIcons: Record<IErrorCode, string> = {
  "404": error404,
  "500": error500,
  "503": error500,
  "400": error500,
  "403": error500,
};

const errorTexts = (
  isFront?: boolean,
): Record<IErrorCode, ParseKeys<"error">> => ({
  "404": `errors.error404${isFront ? "Front" : ""}.title`,
  "500": `errors.error500${isFront ? "Front" : ""}.title`,
  "503": "errors.error503.title",
  "400": "errors.error400.title",
  "403": "errors.error403.title",
});

const errorDescriptions = (
  isFront?: boolean,
): Record<IErrorCode, ParseKeys<"error">> => ({
  "404": `errors.error404${isFront ? "Front" : ""}.des`,
  "500": `errors.error500${isFront ? "Front" : ""}.des`,
  "503": "errors.error503.des",
  "400": "errors.error400.des",
  "403": "errors.error403.des",
});

export function ErrorPage(props: IErrorComponentProps) {
  const { t } = useTranslation("error");

  const { type, isFront } = props;
  const icon = useMemo(() => errorIcons[type] || "", [type]);
  const title = useMemo(() => errorTexts(isFront)[type] || "", [isFront, type]);
  const description = useMemo(
    () => errorDescriptions(isFront)[type] || "",
    [isFront, type],
  );

  return (
    <div className={styles.container}>
      <img src={icon} alt={""} />
      <div className={styles.text}>
        <Typography
          fontSize={"2xl"}
          fontWeight={"extra-bold"}
          color={"primary-main"}
        >
          {title ? t(title) : ""}
        </Typography>
        <Typography
          fontSize={"sm"}
          fontWeight={"medium"}
          color={"primary-text"}
          center
          className={styles.des}
        >
          {description ? t(description) : ""}
        </Typography>
      </div>
      <div className={styles.btns}>
        <Button mode={"secondary"} label={t("errors.contact")} size={"big"} />
        <Button
          mode={"main"}
          label={type === 404 ? t("errors.error404.back") : t("errors.retry")}
          size={"big"}
          onClick={() => {
            if (type === 404) window.location.href = "/";
            else window.location.reload();
          }}
        />
      </div>
    </div>
  );
}
